import { TASK_DETAIL } from '../../actions/types';

const initialState = {
  successMsg: '',
  errorMsg: '',
  resTitle: '',
  resFooter: '',
  currentTask: {},
  tpInfoVisible: true,
  substagesVisible: true,
  opsInfoVisible: true,
  modalType: null
};

export default function taskDetailReducer(state = initialState, action) {
  switch (action.type) {
    case TASK_DETAIL.SET_RES_MSG:
      return {
        ...state,
        successMsg: action.payload.success,
        errorMsg: action.payload.error,
        resTitle: action.payload.title,
        resFooter: action.payload.footer
      };
    case TASK_DETAIL.SET_TASK:
      return {
        ...state,
        currentTask: action.payload
      };
    case TASK_DETAIL.SET_TP_INFO_VISIBLE:
      return {
        ...state,
        tpInfoVisible: action.payload
      };
    case TASK_DETAIL.SET_SUBSTAGES_VISIBLE:
      return {
        ...state,
        substagesVisible: action.payload
      };
    case TASK_DETAIL.SET_OPS_INFO_VISIBLE:
      return {
        ...state,
        opsInfoVisible: action.payload
      };
    case TASK_DETAIL.SET_MODAL_TYPE:
      return {
        ...state,
        modalType: action.payload
      };
    default:
      return state;
  }
}
